import { render } from "./FavoriteItem.vue?vue&type=template&id=69c86b70&scoped=true"
import script from "./FavoriteItem.vue?vue&type=script&lang=js"
export * from "./FavoriteItem.vue?vue&type=script&lang=js"

import "./FavoriteItem.vue?vue&type=style&index=0&id=69c86b70&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69c86b70"]])

export default __exports__